<template>
  <section class="dorm-module dorm-v3-page dp-layout" :class="{ 'config-layout': mode === 'config' }">

    <section v-if="mode !== 'config'" class="dp-left">
      <DepartmentPane directory-scope="teaching" pane-title="组织架构" :default-select-root="true" @tree-node-click="treeNodeClick" />
    </section>

    <section class="dp-right dorm-card attendance-main">

      <div v-if="mode !== 'config' && selectedScopeName" class="scope-caption">
        <i class="el-icon-s-operation" />
        <span>当前范围：{{ selectedScopeName }}</span>
        <small>统计该节点及其下属班级的{{ residentTypeName }}</small>
      </div>

      <el-tabs v-model="activeTab" class="dorm-v3-tabs">
        <el-tab-pane v-if="mode !== 'statistics'" label="学校配置" name="config">
          <div class="config-card" v-loading="configLoading">
            <el-alert class="config-explain" type="info" :closable="false" show-icon
              title="启用后系统会按已发布规则的结束时间自动创建固化任务；多个年级结束时间相同只创建一个任务。日报统计时间只生成当天汇总快照，必须晚于所有规则结束时间。" />
            <el-form :model="config" label-width="150px" size="small">
              <el-form-item label="启用宿舍考勤">
                <el-switch v-model="config.Enabled" active-text="开启" inactive-text="关闭" />
                <span class="form-tip">关闭后只保留原始门禁流水，不更新在寝、不生成考勤、不发送家长通知。</span>
              </el-form-item>
              <el-form-item label="家长进出通知">
                <el-switch v-model="config.ParentPushEnabled" active-text="开启" inactive-text="关闭" />
              </el-form-item>
              <el-form-item label="转发门禁考勤">
                <el-switch v-model="config.ForwardToGateEnabled" active-text="开启" inactive-text="关闭" />
                <span class="form-tip">开启后，宿舍流水按反方向计入门禁时段考勤；不写进出校、不推家长。</span>
              </el-form-item>
              <el-form-item label="日报统计时间">
                <el-time-picker v-model="config.DailySummaryTime" value-format="HH:mm" format="HH:mm"
                  :clearable="false" />
                <span class="form-tip">每天此时间自动统计当天离寝、归寝并生成宿舍日报，建议保持 23:40。</span>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-check" :loading="configSaving"
                  @click="saveConfig">保存配置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>

        <el-tab-pane v-if="mode !== 'statistics'" label="年级准点规则" name="rules" class="list-tab-pane">
          <div class="toolbar-row">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="openRule">新增规则</el-button>
            <span class="form-tip">每个年级配置离寝、归寝两个时段。准点用于判断是否按时，结束时间后系统固化未离寝/未归寝；日报统计时间必须晚于所有结束时间。</span>
          </div>
          <div class="tbl-scroll-host">
            <el-table :data="rules" v-loading="rulesLoading" size="small" class="rule-table" height="100%" style="width: 100%">
              <el-table-column prop="RuleName" label="规则名称" width="220" show-overflow-tooltip />
              <el-table-column label="适用年级" min-width="160">
                <template slot-scope="s">
                  <el-button
                    v-if="gradeLabelList(s.row.GradeDepartmentIds).length"
                    type="text"
                    size="small"
                    icon="el-icon-office-building"
                    class="kq-dept-link-btn"
                    @click.stop="openGradeViewDialog(s.row)">
                    已选 {{ gradeLabelList(s.row.GradeDepartmentIds).length }} 个年级
                  </el-button>
                  <span v-else class="ac-empty-dash">未配置</span>
                </template>
              </el-table-column>
              <el-table-column label="离寝时段" min-width="250">
                <template slot-scope="s"><span class="rule-time-text">{{ ruleTimeText(s.row, 'Morning')
                    }}</span></template>
              </el-table-column>
              <el-table-column label="归寝时段" min-width="250">
                <template slot-scope="s"><span class="rule-time-text">{{ ruleTimeText(s.row, 'Evening')
                    }}</span></template>
              </el-table-column>
              <el-table-column label="状态" width="100" align="center">
                <template slot-scope="s">
                  <el-tag size="mini" :type="ruleStatusType(s.row.Status)">{{ ruleStatusText(s.row.Status) }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="140" align="center">
                <template slot-scope="s">
                  <el-button type="text" @click="openRule(s.row)">编辑</el-button>
                  <el-button v-if="ruleCanDisable(s.row)" type="text" class="danger-text"
                    @click="disableRule(s.row)">停用</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <el-tab-pane v-if="mode !== 'config'" label="日报汇总" name="summary" class="summary-tab-pane">
          <div class="summary-tab-body">
            <div class="toolbar-row">
              <el-date-picker v-model="summaryDate" type="date" value-format="yyyy-MM-dd" size="small"
                :clearable="false" @change="onSummaryDateChange" />
              <el-button size="small" type="primary" icon="el-icon-refresh" @click="loadSummary">刷新</el-button>
              <el-radio-group v-model="attendanceTab" size="mini" class="attendance-tab-switch" @change="attendanceTabManual = true">
                <el-radio-button label="morning">离寝</el-radio-button>
                <el-radio-button label="evening">归寝</el-radio-button>
              </el-radio-group>
              <span v-if="summary.DataModeDescription" class="mode-tip"><i class="el-icon-info" />{{
                summary.DataModeDescription
              }}</span>
            </div>
            <div class="summary-content" v-loading="summaryLoading">
              <section class="summary-block" :class="{ 'is-collapsed': summaryBlockCollapsed }">
                <div class="summary-block-head" @click="summaryBlockCollapsed = !summaryBlockCollapsed">
                  <div class="summary-block-title">
                    <i :class="summaryBlockCollapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-down'" />
                    <strong>{{ summary.ScopeName || selectedScopeName || '节点' }}汇总</strong>
                  </div>
                  <span class="summary-link" @click.stop="openMetricDetails(residentTypeName, {})">{{ residentTypeName }} {{ summary.Total.ResidentCount || 0
                  }}</span>
                </div>
                <div v-show="!summaryBlockCollapsed" class="summary-block-body">
                <div class="metric-groups">
                  <div class="metric-group overview">
                    <div class="metric-group-head">
                      <strong>人数</strong>
                    <span>当前节点入住学生</span>
                    </div>
                    <div class="metric-grid" style="--metric-cols: 1">
                      <div class="metric-card" @click="openMetricDetails(residentTypeName, {})">
                        <em>{{ residentTypeName }}</em>
                        <b>{{ summary.Total.ResidentCount || 0 }}</b>
                      </div>
                    </div>
                  </div>
                  <div v-if="attendanceTab === 'morning'" class="metric-group morning">
                    <div class="metric-group-head">
                      <strong>离寝考勤</strong>
                      <span v-if="summary.DataMode === 'REALTIME' && summary.Total.MorningSettlementTime">当天离寝截止 {{ String(summary.Total.MorningSettlementTime).substring(0, 5) }}</span>
                    </div>
                    <div class="metric-grid" style="--metric-cols: 3">
                      <div class="metric-card"
                        @click="openMetricDetails('离寝合计（含晚离）', { attendanceItem: 'MORNING_EXIT', result: 'EXITED_OR_LATE' })">
                        <em>离寝合计</em>
                        <b class="ok">{{ summary.Total.MorningExitedCount != null ?
                          summary.Total.MorningExitedCount :
                          ((summary.Total.MorningNormalCount || 0) + (summary.Total.MorningLateExitCount || 0)) }}</b>
                      </div>
                      <div class="metric-card"
                        @click="openMetricDetails('未离寝', { attendanceItem: 'MORNING_EXIT', result: 'NOT_EXITED' })">
                        <em>未离寝</em>
                        <b class="bad">{{ summary.Total.MorningNotExitedCount || 0 }}</b>
                      </div>
                      <div class="metric-card"
                        @click="openMetricDetails('晚离', { attendanceItem: 'MORNING_EXIT', result: 'LATE_EXIT' })">
                        <em>晚离</em>
                        <b class="bad">{{ summary.Total.MorningLateExitCount || 0 }}</b>
                      </div>
                    </div>
                  </div>
                  <div v-if="attendanceTab === 'evening'" class="metric-group evening">
                    <div class="metric-group-head">
                      <strong>归寝考勤</strong>
                      <span v-if="summary.DataMode === 'REALTIME' && summary.Total.EveningSettlementTime">当天归寝截止 {{ String(summary.Total.EveningSettlementTime).substring(0, 5) }}</span>
                    </div>
                    <div class="metric-grid" style="--metric-cols: 5">
                      <div class="metric-card"
                        @click="openMetricDetails('归寝合计（含晚归）', { attendanceItem: 'EVENING_RETURN', result: 'RETURNED_OR_LATE' })">
                        <em>归寝合计</em>
                        <b class="ok">{{ summary.Total.EveningReturnedCount != null ?
                          summary.Total.EveningReturnedCount
                          : ((summary.Total.EveningNormalCount || 0) + (summary.Total.EveningLateReturnCount || 0)) }}</b>
                      </div>
                      <div class="metric-card"
                        @click="openMetricDetails('未归寝', { attendanceItem: 'EVENING_RETURN', result: 'NOT_RETURNED' })">
                        <em>未归寝</em>
                        <b class="bad">{{ summary.Total.EveningNotReturnedCount || 0 }}</b>
                      </div>
                      <div class="metric-card"
                        @click="openMetricDetails('晚归', { attendanceItem: 'EVENING_RETURN', result: 'LATE_RETURN' })">
                        <em>晚归</em>
                        <b class="bad">{{ summary.Total.EveningLateReturnCount || 0 }}</b>
                      </div>
                      <div class="metric-card"
                        @click="openMetricDetails('超时归寝', { attendanceItem: 'EVENING_RETURN', result: 'OVERTIME_RETURN' })">
                        <em>超时归寝</em>
                        <b class="bad">{{ summary.Total.EveningOvertimeReturnCount || 0 }}</b>
                      </div>
                      <div class="metric-card"
                        @click="openMetricDetails('归寝后离寝', { attendanceItem: 'EVENING_RETURN', result: 'RETURNED_THEN_EXITED' })">
                        <em>归寝后离寝</em>
                        <b class="bad">{{ summary.Total.EveningReturnedThenExitedCount || 0 }}</b>
                      </div>
                    </div>
                  </div>
                  <div class="metric-group other">
                    <div class="metric-group-head">
                      <strong>其他</strong>
                      <span>请假与考勤资格</span>
                    </div>
                    <div class="metric-grid" style="--metric-cols: 3">
                      <div class="metric-card" @click="openMetricDetails('请假', {
                        attendanceItem: attendanceTab === 'morning' ? 'MORNING_EXIT' : 'EVENING_RETURN',
                        result: 'LEAVE'
                      })">
                        <em>请假</em>
                        <b>{{ tabLeaveCount(summary.Total) }}</b>
                      </div>
                      <div class="metric-card" @click="openMetricDetails(attendanceTab === 'morning' ? '离寝未判定' : '归寝未判定', {
                        attendanceItem: attendanceTab === 'morning' ? 'MORNING_EXIT' : 'EVENING_RETURN',
                        result: 'UNJUDGED'
                      })">
                        <em>{{ attendanceTab === 'morning' ? '离寝未判定' : '归寝未判定' }}</em>
                        <b class="wait">{{ tabUnjudgedCount(summary.Total) }}</b>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bar-line"><span>离寝归寝正常率</span><i><b
                      :style="{ width: normalRate(summary.Total) + '%' }" /></i><strong>{{ normalRate(summary.Total)
                      }}%</strong>
                </div>
                </div>
              </section>

              <section class="class-summary">
                <div class="section-head">
                  <div><strong>班级汇总</strong><span>按学段、年级、班级顺序展示</span></div>
                  <small>共 {{ summaryClassTotal }} 个班级</small>
                </div>
                <div class="class-summary-table-host tbl-scroll-host">
                  <el-table :data="summary.Classes" size="small" empty-text="当前节点下暂无班级"
                    :row-class-name="summaryRowClassName" :cell-class-name="summaryCellClassName"
                    height="100%" style="width: 100%;"
                    @cell-click="openClassCellDetails">
                    <el-table-column prop="PeriodName" label="学段" min-width="80" show-overflow-tooltip />
                    <el-table-column prop="GradeName" label="年级" min-width="108" show-overflow-tooltip />
                    <el-table-column prop="ClassName" label="班级" min-width="120" show-overflow-tooltip />
                    <el-table-column prop="ResidentCount" :label="residentTypeName" min-width="90" align="center" show-overflow-tooltip />
                    <el-table-column v-if="attendanceTab === 'morning'" prop="MorningExitedCount" label="离寝合计" width="76" align="center">
                      <template slot-scope="s">{{ s.row.MorningExitedCount != null ? s.row.MorningExitedCount :
                        ((s.row.MorningNormalCount || 0) + (s.row.MorningLateExitCount || 0)) }}</template>
                    </el-table-column>
                    <el-table-column v-if="attendanceTab === 'morning'" prop="MorningNotExitedCount" label="未离寝" width="72" align="center" />
                    <el-table-column v-if="attendanceTab === 'morning'" prop="MorningLateExitCount" label="晚离" width="58" align="center" />
                    <el-table-column v-if="attendanceTab === 'evening'" prop="EveningReturnedCount" label="归寝合计" width="76" align="center">
                      <template slot-scope="s">{{ s.row.EveningReturnedCount != null ? s.row.EveningReturnedCount :
                        ((s.row.EveningNormalCount || 0) + (s.row.EveningLateReturnCount || 0)) }}</template>
                    </el-table-column>
                    <el-table-column v-if="attendanceTab === 'evening'" prop="EveningNotReturnedCount" label="未归寝" width="72" align="center" />
                    <el-table-column v-if="attendanceTab === 'evening'" prop="EveningLateReturnCount" label="晚归" width="58" align="center" />
                    <el-table-column v-if="attendanceTab === 'evening'" prop="EveningOvertimeReturnCount" label="超时归寝" width="84" align="center" />
                    <el-table-column v-if="attendanceTab === 'evening'" prop="EveningReturnedThenExitedCount" label="归寝后离寝" width="90" align="center" />
                    <el-table-column prop="LeaveCount" label="请假" width="54" align="center"><template slot-scope="s">{{
                      tabLeaveCount(s.row) }}</template></el-table-column>
                    <el-table-column prop="UnjudgedCount" :label="attendanceTab === 'morning' ? '离寝未判定' : '归寝未判定'" width="96" align="center">
                      <template slot-scope="s">{{ tabUnjudgedCount(s.row) }}</template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="dialog-pager-wrap class-summary-pager">
                  <el-pagination
                    class="dialog-pager"
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="summaryPage"
                    :page-size="summaryPageSize"
                    :page-sizes="[10, 20, 50, 100]"
                    :total="summaryClassTotal"
                    @size-change="handleSummaryPageSizeChange"
                    @current-change="handleSummaryPageChange"
                  />
                </div>
              </section>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane v-if="mode !== 'config'" label="学生明细" name="details" class="list-tab-pane">
          <div class="toolbar-row">
            <el-date-picker v-model="detailDate" type="date" value-format="yyyy-MM-dd" size="small"
              :clearable="false" />
            <el-input v-model="detailKeyword" class="student-search-input" size="small" clearable
              prefix-icon="el-icon-search" placeholder="搜索学生姓名" @clear="searchDetails"
              @keyup.enter.native="searchDetails" />
            <el-button size="small" type="primary" icon="el-icon-search" @click="searchDetails">查询</el-button>
          </div>
          <div class="tbl-scroll-host">
            <el-table :data="details" v-loading="detailLoading" size="small" height="100%" style="width: 100%">
              <el-table-column label="头像" width="62" align="center">
                <template slot-scope="s">
                  <oss-el-image v-if="s.row.HeadPhotoImage" :src="s.row.HeadPhotoImage"
                    :preview-src-list="[s.row.HeadPhotoImage]" fit="cover" class="student-photo">
                    <div slot="error" class="student-photo-error">
                      <i class="el-icon-picture-outline" />
                    </div>
                  </oss-el-image>
                  <span v-else class="student-avatar">{{ studentInitial(s.row) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="StudentName" label="学生" min-width="110" show-overflow-tooltip />
              <el-table-column prop="ClassName" label="班级" min-width="130" show-overflow-tooltip />
              <el-table-column label="入住信息" min-width="190" show-overflow-tooltip>
                <template slot-scope="s">{{ dormDisplay(s.row) }}</template>
              </el-table-column>
              <el-table-column prop="EligibilityStatus" label="入住状态" width="100">
                <template slot-scope="s">{{ eligibilityText(s.row.EligibilityStatus) }}</template>
              </el-table-column>
              <el-table-column label="离寝" width="100"><template slot-scope="s"><el-tag size="mini"
                    :type="resultType(s.row.MorningResult, s.row)" :class="resultTagClass(s.row.MorningResult)">{{ resultText(s.row.MorningResult, s.row,
                      'MORNING_EXIT') }}</el-tag></template></el-table-column>
              <el-table-column label="归寝" width="100"><template slot-scope="s"><el-tag size="mini"
                    :type="resultType(s.row.EveningResult, s.row)" :class="resultTagClass(s.row.EveningResult)">{{ resultText(s.row.EveningResult, s.row,
                      'EVENING_RETURN') }}</el-tag></template></el-table-column>
              <el-table-column label="操作" width="150" align="center">
                <template slot-scope="s">
                  <el-button v-if="canReview(s.row)" type="text" size="mini"
                    @click="openReview(s.row, 'MORNING_EXIT')">核实离寝</el-button>
                  <el-button v-if="canReview(s.row)" type="text" size="mini"
                    @click="openReview(s.row, 'EVENING_RETURN')">核实归寝</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="dialog-pager-wrap">
            <el-pagination class="dialog-pager" layout="total, prev, pager, next, jumper" :current-page="detailPage"
              :page-size="detailPageSize" :total="detailTotal" @current-change="handleDetailPageChange" />
          </div>
        </el-tab-pane>

        <el-tab-pane v-if="mode !== 'config'" label="核实记录" name="reviewLogs" class="list-tab-pane">
          <div class="toolbar-row">
            <el-date-picker v-model="reviewLogDate" type="date" value-format="yyyy-MM-dd" size="small"
              :clearable="false" />
            <el-input v-model="reviewLogKeyword" class="student-search-input" size="small" clearable
              prefix-icon="el-icon-search" placeholder="搜索学生姓名" @clear="searchReviewLogs"
              @keyup.enter.native="searchReviewLogs" />
            <el-button size="small" type="primary" icon="el-icon-search" @click="searchReviewLogs">查询</el-button>
            <span class="form-tip">这里只展示人工核实记录；学生主状态仍按已离寝、已归寝、晚离、晚归、请假、未判定等业务口径显示。</span>
          </div>
          <div class="tbl-scroll-host">
            <el-table :data="reviewLogs" v-loading="reviewLogLoading" size="small" height="100%" style="width: 100%">
              <el-table-column prop="CreateTime" label="核实时间" width="160" />
              <el-table-column prop="AttendanceDate" label="考勤日期" width="110">
                <template slot-scope="s">{{ formatDate(s.row.AttendanceDate) }}</template>
              </el-table-column>
              <el-table-column prop="StudentName" label="学生" min-width="110" show-overflow-tooltip />
              <el-table-column prop="ClassName" label="班级" min-width="150" show-overflow-tooltip />
              <el-table-column prop="AttendanceItemName" label="项目" width="80" align="center" />
              <el-table-column prop="BeforeResultName" label="核实前" width="90" align="center" />
              <el-table-column prop="AfterResultName" label="核实后" width="90" align="center" />
              <el-table-column prop="ReviewerName" label="核实人" width="110" show-overflow-tooltip />
              <el-table-column prop="Reason" label="说明" min-width="180" show-overflow-tooltip />
            </el-table>
          </div>
          <div class="dialog-pager-wrap">
            <el-pagination class="dialog-pager" layout="total, prev, pager, next, jumper" :current-page="reviewLogPage"
              :page-size="reviewLogPageSize" :total="reviewLogTotal" @current-change="handleReviewLogPageChange" />
          </div>
        </el-tab-pane>
      </el-tabs>
    </section>

    <el-dialog :title="detailDialogTitle" :visible.sync="detailDialogVisible" width="920px"
      custom-class="metric-detail-dialog" append-to-body>
      <div class="toolbar-row metric-detail-toolbar">
        <el-input v-model="metricDetailKeyword" class="metric-detail-search" size="small" clearable
          prefix-icon="el-icon-search" placeholder="搜索姓名、班级" @keyup.enter.native="searchMetricDetails" />
        <el-button size="small" type="primary" icon="el-icon-search" @click="searchMetricDetails">搜索</el-button>
      </div>
      <div class="metric-detail-table-wrap">
        <el-table :data="metricDetails" v-loading="metricDetailLoading" size="small" class="metric-detail-table"
          height="100%">
        <el-table-column label="头像" width="56" align="center">
          <template slot-scope="s">
            <oss-el-image v-if="s.row.HeadPhotoImage" :src="s.row.HeadPhotoImage"
              :preview-src-list="[s.row.HeadPhotoImage]" fit="cover" class="student-photo">
              <div slot="error" class="student-photo-error">
                <i class="el-icon-picture-outline" />
              </div>
            </oss-el-image>
            <span v-else class="student-avatar">{{ studentInitial(s.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="StudentName" label="学生" width="100" show-overflow-tooltip />
        <el-table-column prop="ClassName" label="班级" min-width="118" show-overflow-tooltip />
        <el-table-column label="入住信息" min-width="168" show-overflow-tooltip>
          <template slot-scope="s">{{ dormDisplay(s.row) }}</template>
        </el-table-column>
        <el-table-column prop="EligibilityStatus" label="入住状态" width="92">
          <template slot-scope="s">{{ eligibilityText(s.row.EligibilityStatus) }}</template>
        </el-table-column>
        <el-table-column label="离寝" width="96">
          <template slot-scope="s"><el-tag size="mini" :type="resultType(s.row.MorningResult, s.row)" :class="resultTagClass(s.row.MorningResult)">{{
            resultText(s.row.MorningResult, s.row, 'MORNING_EXIT') }}</el-tag></template>
        </el-table-column>
        <el-table-column label="归寝" width="96">
          <template slot-scope="s"><el-tag size="mini" :type="resultType(s.row.EveningResult, s.row)" :class="resultTagClass(s.row.EveningResult)">{{
            resultText(s.row.EveningResult, s.row, 'EVENING_RETURN') }}</el-tag></template>
        </el-table-column>
        <el-table-column label="操作" width="72" align="center">
          <template slot-scope="s">
            <el-button v-if="canReview(s.row)" type="text" size="mini"
              @click="openReview(s.row, attendanceTab === 'evening' ? 'EVENING_RETURN' : 'MORNING_EXIT')">核实</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>
      <div class="dialog-pager-wrap metric-detail-pager">
        <el-pagination class="dialog-pager" layout="total, prev, pager, next, jumper" :current-page="metricDetailPage"
          :page-size="metricDetailPageSize" :total="metricDetailTotal" @current-change="handleMetricDetailPageChange" />
      </div>
      <div slot="footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="核实宿舍考勤" :visible.sync="reviewVisible" width="480px">
      <el-form :model="reviewForm" label-width="90px" size="small">
        <el-form-item label="学生"><span>{{ reviewForm.StudentName || '-' }}</span></el-form-item>
        <el-form-item label="核实项目"><el-tag>{{ reviewForm.AttendanceItem === 'MORNING_EXIT' ? '离寝' : '归寝'
            }}</el-tag></el-form-item>
        <el-form-item label="核实结果">
          <el-select v-model="reviewForm.Result" style="width: 100%">
            <el-option v-for="item in reviewResultOptions()" :key="item.value" :label="item.label"
              :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="isProblemResult(reviewForm.Result)" label="核实原因">
          <el-input v-model="reviewForm.AbnormalReason" placeholder="如未离寝、晚离、未归寝、晚归" />
        </el-form-item>
        <el-form-item label="核实说明">
          <el-input v-model="reviewForm.Reason" type="textarea" :rows="3" placeholder="请填写现场核实依据" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="reviewVisible = false">取消</el-button>
        <el-button type="primary" :loading="reviewSaving" @click="submitReview">提交核实</el-button>
      </div>
    </el-dialog>

    <el-dialog title="准点规则" :visible.sync="ruleVisible" width="760px">
      <el-form :model="rule" label-width="110px" size="small">
        <el-form-item label="规则名称"><el-input v-model="rule.RuleName" /></el-form-item>
        <el-form-item label="适用年级">
          <el-select v-model="rule.GradeDepartmentIds" multiple filterable collapse-tags placeholder="请选择年级"
            style="width: 100%">
            <el-option v-for="item in gradeOptions" :key="item.Id" :label="item.Name" :value="item.Id" />
          </el-select>
          <div v-if="rule.GradeDepartmentIds && rule.GradeDepartmentIds.length" class="grade-selected-box">
            <span class="grade-selected-label">已选 {{ (rule.GradeDepartmentIds || []).length }} 个年级</span>
            <div class="grade-selected-lines">
              <div v-for="(line, idx) in gradePreviewLines(rule.GradeDepartmentIds)" :key="idx"
                class="grade-selected-line">
                {{ line }}</div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="适用星期">
          <div class="week-wrap">
            <div class="week-checkbox-group">
              <button v-for="n in 7" :key="n" type="button" class="week-chip" :class="{ active: isWeekDayActive(n) }"
                @click="toggleWeekDay(n)">
                周{{ ['一', '二', '三', '四', '五', '六', '日'][n - 1] }}
              </button>
            </div>
            <div class="form-tip week-tip">用于判断该规则在每个星期几生效。</div>
          </div>
        </el-form-item>
        <el-form-item label="离寝时段">
          <div class="rule-time-block">
            <div class="rule-time-inputs">
              <label>开始<el-time-picker v-model="rule.MorningStartTime" value-format="HH:mm" format="HH:mm"
                  :clearable="false" /></label>
              <label>准点<el-time-picker v-model="rule.MorningCheckTime" value-format="HH:mm" format="HH:mm"
                  :clearable="false" /></label>
              <label>结束<el-time-picker v-model="rule.MorningEndTime" value-format="HH:mm" format="HH:mm"
                  :clearable="false" /></label>
            </div>
            <div class="rule-detail-toggle">
              <el-button type="text" size="mini" @click="showMorningRuleDetail = !showMorningRuleDetail">
                {{ showMorningRuleDetail ? '收起规则说明' : '查看规则说明' }}
              </el-button>
            </div>
            <div v-if="showMorningRuleDetail" class="rule-detail-panel">
              <div class="rule-time-axis">
                <div class="axis-track"><span class="axis-before">准点前：用于形成初判</span><span
                    class="axis-after">准点后至结束：只能细化为晚离</span></div>
                <div class="axis-points">
                  <span><b>{{ rule.MorningStartTime || '05:00' }}</b>开始</span>
                  <span><b>{{ rule.MorningCheckTime || '07:40' }}</b>准点判定</span>
                  <span><b>{{ rule.MorningEndTime || '08:00' }}</b>窗口结束</span>
                </div>
              </div>
              <div class="form-tip time-rule-tip">离寝看“准点时是否已离寝”；准点时未离寝记为未离寝，准点后、结束前才离寝细化为晚离；结束后只更新实时状态，不再改离寝结果。</div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="归寝时段">
          <div class="rule-time-block">
            <div class="rule-time-inputs">
              <label>开始<el-time-picker v-model="rule.EveningStartTime" value-format="HH:mm" format="HH:mm"
                  :clearable="false" /></label>
              <label>准点<el-time-picker v-model="rule.EveningCheckTime" value-format="HH:mm" format="HH:mm"
                  :clearable="false" /></label>
              <label>结束<el-time-picker v-model="rule.EveningEndTime" value-format="HH:mm" format="HH:mm"
                  :clearable="false" /></label>
            </div>
            <div class="rule-detail-toggle">
              <el-button type="text" size="mini" @click="showEveningRuleDetail = !showEveningRuleDetail">
                {{ showEveningRuleDetail ? '收起规则说明' : '查看规则说明' }}
              </el-button>
            </div>
            <div v-if="showEveningRuleDetail" class="rule-detail-panel">
              <div class="rule-time-axis evening">
                <div class="axis-track"><span class="axis-before">准点前：用于形成初判</span><span
                    class="axis-after">准点后至结束：只能细化为晚归</span></div>
                <div class="axis-points">
                  <span><b>{{ rule.EveningStartTime || '18:00' }}</b>开始</span>
                  <span><b>{{ rule.EveningCheckTime || '21:40' }}</b>准点判定</span>
                  <span><b>{{ rule.EveningEndTime || '22:00' }}</b>窗口结束</span>
                </div>
              </div>
              <div class="form-tip time-rule-tip">归寝看“准点时是否已在寝”；准点时未归寝记为未归寝，准点后、结束前才进寝细化为晚归；结束后只更新实时状态，不再改归寝结果。</div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer"><el-button @click="ruleVisible = false">取消</el-button><el-button type="primary"
          :loading="ruleSaving" @click="saveRuleV2">保存</el-button></div>
    </el-dialog>

    <!-- 适用年级查看弹窗。最后更新：2026-09-08 -->
    <el-dialog :title="viewGradeDialog.title" :visible.sync="viewGradeDialog.visible" width="600px"
      :close-on-click-modal="false" append-to-body custom-class="kq-dept-view-dialog">
      <div class="kq-view-head">
        <div class="kq-view-head-item">
          <span class="label">规则：</span>
          <span class="val">{{ viewGradeDialog.ruleName || '-' }}</span>
        </div>
        <div class="kq-view-head-item">
          <span class="label">适用范围：</span>
          <span class="val">{{ selectedScopeName || '-' }}</span>
        </div>
        <div class="kq-view-head-item">
          <span class="label">总数：</span>
          <span class="val count-badge">{{ viewGradeDialog.grades ? viewGradeDialog.grades.length : 0 }} 个年级</span>
        </div>
      </div>

      <div class="kq-view-toolbar">
        <el-input v-model="viewGradeDialog.filterKey" size="small" placeholder="搜索年级名称..." prefix-icon="el-icon-search"
          clearable class="kq-view-search-input" />
        <el-button size="small" type="primary" plain icon="el-icon-document-copy" @click="copyAllGradeNames">
          复制全部年级
        </el-button>
      </div>

      <div class="kq-view-table-wrap">
        <el-table :data="filteredViewGrades" size="small" max-height="320" border stripe class="kq-view-table">
          <el-table-column type="index" label="序号" width="70" align="center" />
          <el-table-column prop="name" label="年级名称" min-width="240">
            <template slot-scope="scope">
              <span class="dept-text">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" icon="el-icon-document-copy" @click="copySingleGradeName(scope.row.name)">复制</el-button>
            </template>
          </el-table-column>
          <div slot="empty" class="kq-view-empty">暂无匹配的年级</div>
        </el-table>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="viewGradeDialog.visible = false">关闭</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import DepartmentPane from '../../components/DepartmentPane'
import { getDormAttendanceV3Config, saveDormAttendanceV3Config, getDormAttendanceV3Rules, getDormAttendanceV3GradeOptions, saveDormAttendanceV3Rule, disableDormAttendanceV3Rule, getDormAttendanceV3Summary, getDormAttendanceV3Details, reviewDormAttendanceV3, getDormAttendanceV3ReviewLogs } from '../../api/modules/dormitory'
import { getUnifiedPageSize, setUnifiedPageSize } from '../../utils/elPaginationUnify'
import '../../styles/dorm-module.css'
import { toDeptId, treeNodeDeptId } from '../../utils/deptCascaderProps'

export default {
  components: { DepartmentPane },
  props: {
    mode: { type: String, default: 'statistics' }
  },
  data() {
    return {
      activeTab: this.mode === 'config' ? 'config' : 'summary',
      attendanceTab: 'morning',
      attendanceTabManual: false,
      schoolId: '',
      residentTypeName: '入住人数',
      schId: '',
      selectedScopeName: '',
      selectedScopeType: '',
      summaryBlockCollapsed: false,
      config: { SchoolDepartmentId: 0, SchId: '', Enabled: false, ParentPushEnabled: false, ForwardToGateEnabled: false, DailySummaryTime: '23:40' },
      configLoading: false,
      configSaving: false,
      rules: [],
      gradeOptions: [],
      rulesLoading: false,
      ruleVisible: false,
      ruleSaving: false,
      rule: {},
      showMorningRuleDetail: false,
      showEveningRuleDetail: false,
      summaryDate: this.today(),
      detailDate: this.today(),
      detailKeyword: '',
      reviewLogDate: this.today(),
      reviewLogKeyword: '',
      summary: { ScopeDepartmentId: 0, ScopeName: '', ScopeType: '', DataModeDescription: '', Total: {}, Classes: [], ClassCount: 0 },
      summaryLoading: false,
      summaryRequestId: 0,
      summaryPage: 1,
      summaryPageSize: getUnifiedPageSize(),
      summaryClassTotal: 0,
      details: [],
      detailLoading: false,
      detailRequestId: 0,
      detailPage: 1,
      detailPageSize: getUnifiedPageSize(),
      detailTotal: 0,
      detailDialogVisible: false,
      detailDialogTitle: '明细',
      metricDetails: [],
      metricDetailLoading: false,
      metricDetailRequestId: 0,
      metricDetailFilter: {},
      metricDetailKeyword: '',
      metricDetailPage: 1,
      metricDetailPageSize: getUnifiedPageSize(),
      metricDetailTotal: 0,
      metricDetailRequestKey: '',
      reviewVisible: false,
      reviewSaving: false,
      reviewForm: {},
      reviewLogs: [],
      reviewLogLoading: false,
      reviewLogRequestId: 0,
      reviewLogPage: 1,
      reviewLogPageSize: getUnifiedPageSize(),
      reviewLogTotal: 0,
      schoolChangeRequestId: 0,
      // 适用年级查看弹窗。最后更新：2026-09-08
      viewGradeDialog: {
        visible: false,
        title: '适用年级',
        ruleName: '',
        grades: [],
        filterKey: '',
      },
    }
  },
  computed: {
    // 弹窗中过滤后的年级列表。最后更新：2026-09-08
    filteredViewGrades() {
      const list = this.viewGradeDialog.grades || []
      const key = (this.viewGradeDialog.filterKey || '').trim().toLowerCase()
      if (!key) {
        return list.map(name => ({ name }))
      }
      return list
        .filter(name => String(name).toLowerCase().includes(key))
        .map(name => ({ name }))
    }
  },
  mounted() {
    if (this.mode === 'config') {
      this.schoolId = this.$store.state.activeSchoolId || window.localStorage.getItem('activeSchoolId') || ''
      this.selectedScopeName = this.$store.state.activeSchoolName || window.localStorage.getItem('activeSchoolName') || ''
      this.loadResidentTypeName()
      this.loadConfig()
      this.loadRules()
      this.loadGradeOptions()
    }
  },
  watch: {
    '$store.state.activeSchoolId': {
      handler(value, oldValue) {
        if (value == null || String(value) === String(oldValue)) return
        this.handleGlobalSchoolChange(value)
      }
    },
    activeTab(value) {
      if (value === 'details' && this.details.length === 0 && this.detailTotal === 0) this.loadDetails()
      if (value === 'reviewLogs' && this.reviewLogs.length === 0) this.loadReviewLogs()
    }
  },
  methods: {
    today() { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}` },
    emptySummary() { return { ScopeDepartmentId: 0, ScopeName: '', ScopeType: '', DataModeDescription: '', Total: {}, Classes: [], ClassCount: 0 } },
    emptyConfig() { return { SchoolDepartmentId: 0, SchId: '', Enabled: false, ParentPushEnabled: false, ForwardToGateEnabled: false, DailySummaryTime: '23:40' } },
    handleGlobalSchoolChange(value) {
      const nextSchoolId = String(value || '')
      if (!nextSchoolId || nextSchoolId === String(this.schoolId || '')) return
      this.schoolId = nextSchoolId
      this.schId = ''
      this.loadResidentTypeName()
      this.selectedScopeName = this.$store.state.activeSchoolName || window.localStorage.getItem('activeSchoolName') || ''
      this.selectedScopeType = 'school'
      const requestId = ++this.schoolChangeRequestId

      // 切换学校时先清空旧学校数据，避免旧请求或旧页面状态短暂残留。
      this.config = this.emptyConfig()
      this.rules = []
      this.gradeOptions = []
      this.summary = this.emptySummary()
      this.summaryPage = 1
      this.summaryClassTotal = 0
      this.details = []
      this.detailPage = 1
      this.detailTotal = 0
      this.metricDetails = []
      this.reviewLogs = []
      this.metricDetailTotal = 0
      this.reviewLogTotal = 0
      this.metricDetailRequestId += 1
      this.reviewLogRequestId += 1
      this.detailDialogVisible = false
      this.reviewVisible = false
      this.summaryRequestId += 1
      this.detailRequestId += 1

      const tasks = this.mode === 'config'
        ? [this.loadConfig(requestId), this.loadRules(requestId), this.loadGradeOptions(requestId)]
        : [this.loadSummary()]
      if (this.mode !== 'config' && this.activeTab === 'details') tasks.push(this.loadDetails())
      return Promise.all(tasks)
    },
    async loadResidentTypeName() {
      this.residentTypeName = '入住人数'
    },
    treeNodeClick(data) {
      // 学校/范围 Id 用字符串，勿 Number()。最后修改：2026-10-18
      this.schoolId = treeNodeDeptId(data) || toDeptId(data && data.value)
      this.selectedScopeName = data.label || ''
      this.selectedScopeType = data.DeptOrgType || data.deptOrgType || ''
      this.loadResidentTypeName()
      if (this.mode === 'config') {
        this.loadConfig()
        this.loadRules()
        this.loadGradeOptions()
      } else {
        this.detailPage = 1
        this.reviewLogPage = 1
        this.summaryPage = 1
        this.loadSummary()
        if (this.activeTab === 'details') this.loadDetails()
        if (this.activeTab === 'reviewLogs') this.loadReviewLogs()
      }
    },
    async loadConfig(schoolChangeRequestId) { if (!this.schoolId) return; const schoolId = String(this.schoolId); this.configLoading = true; try { const r = await getDormAttendanceV3Config({ departmentId: schoolId }); if (String(this.schoolId) === schoolId && (schoolChangeRequestId == null || schoolChangeRequestId === this.schoolChangeRequestId)) this.config = (r.data && r.data.response) || this.config } finally { if (String(this.schoolId) === schoolId) this.configLoading = false } },
    async saveConfig() { this.configSaving = true; try { const r = await saveDormAttendanceV3Config({ ...this.config, SchoolDepartmentId: toDeptId(this.schoolId) }); if (r.data && r.data.success) this.$message.success(r.data.msg || '保存成功'); else this.$message.error((r.data && r.data.msg) || '保存失败') } finally { this.configSaving = false } },
    async loadRules(schoolChangeRequestId) { if (!this.schoolId) return; const schoolId = String(this.schoolId); this.rulesLoading = true; try { const r = await getDormAttendanceV3Rules({ departmentId: schoolId }); if (String(this.schoolId) === schoolId && (schoolChangeRequestId == null || schoolChangeRequestId === this.schoolChangeRequestId)) this.rules = (r.data && r.data.response) || [] } finally { if (String(this.schoolId) === schoolId) this.rulesLoading = false } },
    async loadGradeOptions(schoolChangeRequestId) { if (!this.schoolId) return; const schoolId = String(this.schoolId); try { const r = await getDormAttendanceV3GradeOptions({ departmentId: schoolId }); if (String(this.schoolId) === schoolId && (schoolChangeRequestId == null || schoolChangeRequestId === this.schoolChangeRequestId)) this.gradeOptions = (r.data && r.data.response) || [] } finally { } },
    openRule(row) {
      this.showMorningRuleDetail = false
      this.showEveningRuleDetail = false
      const normalize = (value, fallback) => value || fallback
      const checkBeforeEnd = (check, end, fallback) => {
        if (!check || check === end) return this.shiftTime(end || fallback, -20)
        return check
      }
      if (row) {
        const morningEnd = normalize(row.MorningEndTime || row.MorningCheckTime, '08:00')
        const eveningEnd = normalize(row.EveningEndTime || row.EveningCheckTime, '22:00')
        this.rule = {
          ...row,
          GradeDepartmentIds: [...(row.GradeDepartmentIds || [])],
          MorningStartTime: normalize(row.MorningStartTime, '05:00'),
          MorningCheckTime: checkBeforeEnd(row.MorningCheckTime, morningEnd, '08:00'),
          MorningEndTime: morningEnd,
          EveningStartTime: normalize(row.EveningStartTime, '18:00'),
          EveningCheckTime: checkBeforeEnd(row.EveningCheckTime, eveningEnd, '22:00'),
          EveningEndTime: eveningEnd
        }
      } else {
        this.rule = {
          SchoolDepartmentId: toDeptId(this.schoolId),
          GradeDepartmentIds: [],
          UsingWeekDays: [1, 2, 3, 4, 5],
          EffectiveFrom: this.today(),
          MorningStartTime: '05:00',
          MorningCheckTime: '07:40',
          MorningEndTime: '08:00',
          EveningStartTime: '18:00',
          EveningCheckTime: '21:40',
          EveningEndTime: '22:00',
          Status: 'PUBLISHED'
        }
      }
      this.ruleVisible = true
    },
    async saveRuleV2() {
      if (!this.isTimeIncreasing(this.rule.MorningStartTime, this.rule.MorningCheckTime, this.rule.MorningEndTime)) {
        this.$message.warning('离寝时段必须满足：开始时间 < 准点时间 < 结束时间')
        return
      }
      if (!this.isTimeIncreasing(this.rule.EveningStartTime, this.rule.EveningCheckTime, this.rule.EveningEndTime)) {
        this.$message.warning('归寝时段必须满足：开始时间 < 准点时间 < 结束时间')
        return
      }
      this.ruleSaving = true
      try {
        const data = { ...this.rule, SchoolDepartmentId: toDeptId(this.schoolId), GradeDepartmentIds: (this.rule.GradeDepartmentIds || []).map(v => toDeptId(v)).filter(Boolean) }
        const r = await saveDormAttendanceV3Rule(data)
        if (r.data && r.data.success) { this.$message.success('保存成功'); this.ruleVisible = false; this.loadRules() } else this.$message.error((r.data && r.data.msg) || '保存失败')
      } finally {
        this.ruleSaving = false
      }
    },
    async disableRule(row) {
      if (!row || !row.Id) return
      try {
        await this.$confirm('停用后该规则不再参与后续宿舍考勤判定，历史日报不受影响。是否继续？', '停用规则', {
          confirmButtonText: '停用',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (e) {
        return
      }
      const r = await disableDormAttendanceV3Rule({ id: row.Id, departmentId: toDeptId(this.schoolId) })
      if (r.data && r.data.success) {
        this.$message.success(r.data.msg || '已停用')
        this.loadRules()
      } else {
        this.$message.error((r.data && r.data.msg) || '停用失败')
      }
    },
    async loadSummary() { if (!this.schoolId) return; const requestId = ++this.summaryRequestId; this.summary = this.emptySummary(); this.summaryLoading = true; try { const r = await getDormAttendanceV3Summary({ departmentId: this.schoolId, attendanceDate: this.summaryDate, page: this.summaryPage, intPageSize: this.summaryPageSize }); if (requestId !== this.summaryRequestId) return; const data = (r.data && r.data.response) || this.emptySummary(); data.Total = data.Total || {}; data.Classes = data.Classes || []; this.summaryClassTotal = data.ClassCount != null ? data.ClassCount : data.Classes.length; this.summary = data; if (!this.attendanceTabManual && (data.DefaultAttendanceTab === 'morning' || data.DefaultAttendanceTab === 'evening')) this.attendanceTab = data.DefaultAttendanceTab } finally { if (requestId === this.summaryRequestId) this.summaryLoading = false } },
    onSummaryDateChange() { this.summaryPage = 1; this.attendanceTabManual = false; this.loadSummary() },
    handleSummaryPageChange(page) { this.summaryPage = page; this.loadSummary() },
    handleSummaryPageSizeChange(size) {
      const nextSize = Number(size) || 10
      setUnifiedPageSize(nextSize)
      this.summaryPageSize = nextSize
      this.summaryPage = 1
      this.loadSummary()
    },
    async loadDetails() { if (!this.schoolId) return; const requestId = ++this.detailRequestId; this.details = []; this.detailLoading = true; try { const r = await getDormAttendanceV3Details({ departmentId: this.schoolId, attendanceDate: this.detailDate, page: this.detailPage, intPageSize: this.detailPageSize, name: (this.detailKeyword || '').trim() }); if (requestId !== this.detailRequestId) return; const page = (r.data && r.data.response) || {}; this.details = page.data || []; this.detailTotal = page.dataCount || 0 } finally { if (requestId === this.detailRequestId) this.detailLoading = false } },
    searchDetails() { this.detailPage = 1; this.loadDetails() },
    handleDetailPageChange(page) { this.detailPage = page; this.loadDetails() },
    async openMetricDetails(title, filter) {
      if (!this.schoolId) return
      const requestKey = `${String(this.schoolId)}|${this.summaryDate}|${JSON.stringify(filter || {})}`
      if (this.detailDialogVisible && this.metricDetailLoading && this.metricDetailRequestKey === requestKey) return
      this.metricDetailRequestKey = requestKey
      this.detailDialogTitle = `${this.selectedScopeName || '当前范围'} · ${this.summaryDate} · ${title}`
      this.metricDetailFilter = filter || {}
      this.metricDetailKeyword = ''
      this.metricDetailPage = 1
      this.metricDetails = []
      this.metricDetailTotal = 0
      this.detailDialogVisible = true
      await this.loadMetricDetails()
    },
    async loadMetricDetails() {
      if (!this.schoolId) return
      const schoolId = String(this.schoolId)
      const requestId = ++this.metricDetailRequestId
      this.metricDetailLoading = true
      try {
        const r = await getDormAttendanceV3Details({ departmentId: schoolId, attendanceDate: this.summaryDate, page: this.metricDetailPage, intPageSize: this.metricDetailPageSize, ...this.metricDetailFilter, name: (this.metricDetailKeyword || '').trim() })
        if (requestId !== this.metricDetailRequestId || schoolId !== String(this.schoolId)) return
        const page = (r.data && r.data.response) || {}
        this.metricDetails = page.data || []
        this.metricDetailTotal = page.dataCount || 0
      } finally {
        if (requestId === this.metricDetailRequestId) this.metricDetailLoading = false
      }
    },
    searchMetricDetails() {
      this.metricDetailPage = 1
      this.loadMetricDetails()
    },
    handleMetricDetailPageChange(page) {
      this.metricDetailPage = page
      this.loadMetricDetails()
    },
    async loadReviewLogs() {
      if (!this.schoolId) return
      const schoolId = String(this.schoolId)
      const requestId = ++this.reviewLogRequestId
      this.reviewLogLoading = true
      try {
        const r = await getDormAttendanceV3ReviewLogs({ departmentId: schoolId, attendanceDate: this.reviewLogDate, page: this.reviewLogPage, intPageSize: this.reviewLogPageSize, name: (this.reviewLogKeyword || '').trim() })
        if (requestId !== this.reviewLogRequestId || schoolId !== String(this.schoolId)) return
        const page = (r.data && r.data.response) || {}
        this.reviewLogs = page.data || []
        this.reviewLogTotal = page.dataCount || 0
      } finally {
        if (requestId === this.reviewLogRequestId) this.reviewLogLoading = false
      }
    },
    handleReviewLogPageChange(page) {
      this.reviewLogPage = page
      this.loadReviewLogs()
    },
    searchReviewLogs() {
      this.reviewLogPage = 1
      this.loadReviewLogs()
    },
    formatDate(value) {
      return value ? String(value).substring(0, 10) : ''
    },
    canReview(row) {
      return row && row.EligibilityStatus === 'ELIGIBLE'
    },
    openReview(row, item) {
      if (!this.canReview(row)) return
      this.reviewForm = {
        DailyAttendanceId: Number(row.Id || 0),
        SchoolDepartmentId: toDeptId(this.schoolId || row.SchoolDepartmentId),
        SchId: this.schId || this.config.SchId || row.SchId || '',
        StudentId: Number(row.StudentId || 0),
        AttendanceDate: row.AttendanceDate
          ? String(row.AttendanceDate).substring(0, 10)
          : (this.activeTab === 'details' ? this.detailDate : this.summaryDate),
        StudentName: row.StudentName || '',
        AttendanceItem: item,
        Result: item === 'MORNING_EXIT' ? 'EXITED' : 'RETURNED',
        AbnormalReason: '',
        Reason: '',
        LockResult: true
      }
      this.reviewVisible = true
    },
    reviewResultOptions() {
      if (this.reviewForm.AttendanceItem === 'EVENING_RETURN') {
        return [
          { label: '已归寝', value: 'RETURNED' },
          { label: '未归寝', value: 'NOT_RETURNED' },
          { label: '晚归', value: 'LATE_RETURN' },
          { label: '请假', value: 'LEAVE' }
        ]
      }
      return [
        { label: '已离寝', value: 'EXITED' },
        { label: '未离寝', value: 'NOT_EXITED' },
        { label: '晚离', value: 'LATE_EXIT' },
        { label: '请假', value: 'LEAVE' }
      ]
    },
    isProblemResult(value) {
      return ['NOT_EXITED', 'LATE_EXIT', 'NOT_RETURNED', 'LATE_RETURN'].includes(value)
    },
    async submitReview() {
      if (!this.reviewForm.StudentId || !this.reviewForm.SchoolDepartmentId || !this.reviewForm.AttendanceDate) {
        this.$message.warning('缺少学生、学校或考勤日期')
        return
      }
      if (!this.reviewForm.Reason || !this.reviewForm.Reason.trim()) {
        this.$message.warning('请填写核实说明')
        return
      }
      this.reviewSaving = true
      try {
        const r = await reviewDormAttendanceV3(this.reviewForm)
        if (r.data && r.data.success) {
          this.$message.success(r.data.msg || '核实完成')
          this.reviewVisible = false
          const refreshTasks = [this.loadSummary()]
          if (this.activeTab === 'details') refreshTasks.push(this.loadDetails())
          await Promise.all(refreshTasks)
          if (this.activeTab === 'reviewLogs') await this.loadReviewLogs()
          if (this.detailDialogVisible) await this.loadMetricDetails()
        } else {
          this.$message.error((r.data && r.data.msg) || '核实失败')
        }
      } finally {
        this.reviewSaving = false
      }
    },
    isWeekDayActive(day) {
      return Array.isArray(this.rule.UsingWeekDays) && this.rule.UsingWeekDays.includes(day)
    },
    toggleWeekDay(day) {
      if (!Array.isArray(this.rule.UsingWeekDays)) this.$set(this.rule, 'UsingWeekDays', [])
      const idx = this.rule.UsingWeekDays.indexOf(day)
      if (idx >= 0) this.rule.UsingWeekDays.splice(idx, 1)
      else this.rule.UsingWeekDays.push(day)
    },
    ruleTimeText(row, prefix) {
      const start = row[`${prefix}StartTime`] || (prefix === 'Morning' ? '05:00' : '18:00')
      const end = row[`${prefix}EndTime`] || row[`${prefix}CheckTime`] || (prefix === 'Morning' ? '08:00' : '22:00')
      const check = row[`${prefix}CheckTime`] && row[`${prefix}CheckTime`] !== end ? row[`${prefix}CheckTime`] : this.shiftTime(end, -20)
      return `${start} 开始 / ${check} 准点 / ${end} 结束`
    },
    ruleStatusText(status) {
      const value = String(status || '').toUpperCase()
      if (value === 'PUBLISHED') return '已启用'
      if (value === 'DRAFT') return '草稿'
      if (value === 'DISABLED') return '已停用'
      return status || '—'
    },
    ruleStatusType(status) {
      const value = String(status || '').toUpperCase()
      if (value === 'PUBLISHED') return 'success'
      if (value === 'DRAFT') return 'warning'
      if (value === 'DISABLED') return 'info'
      return 'info'
    },
    ruleCanDisable(row) {
      return String(row && row.Status || '').toUpperCase() === 'PUBLISHED'
    },
    shiftTime(value, minutes) {
      const parts = String(value || '').split(':')
      if (parts.length < 2) return value
      const h = Number(parts[0])
      const m = Number(parts[1])
      if (Number.isNaN(h) || Number.isNaN(m)) return value
      let total = h * 60 + m + minutes
      total = Math.max(0, Math.min(23 * 60 + 59, total))
      return `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`
    },
    isTimeIncreasing(start, check, end) {
      const toMinutes = v => {
        const parts = String(v || '').split(':')
        if (parts.length < 2) return NaN
        return Number(parts[0]) * 60 + Number(parts[1])
      }
      const s = toMinutes(start)
      const c = toMinutes(check)
      const e = toMinutes(end)
      return !Number.isNaN(s) && !Number.isNaN(c) && !Number.isNaN(e) && s < c && c < e
    },
    gradeLabelList(ids) {
      const list = Array.isArray(ids) ? ids : []
      if (!list.length) return []
      const map = new Map((this.gradeOptions || []).map(x => [String(x.Id), x.Name]))
      return list.map(id => map.get(String(id)) || id).filter(Boolean)
    },
    // 打开适用年级查看弹窗。最后更新：2026-09-08
    openGradeViewDialog(row) {
      if (!row) return
      const list = this.gradeLabelList(row.GradeDepartmentIds)
      this.viewGradeDialog = {
        visible: true,
        title: `查看适用年级 - ${row.RuleName || '宿舍规则'}`,
        ruleName: row.RuleName || '',
        grades: list,
        filterKey: '',
      }
    },
    copyAllGradeNames() {
      const names = (this.filteredViewGrades || []).map(item => item.name).filter(Boolean)
      if (!names.length) {
        this.$message.warning('暂无可复制的内容')
        return
      }
      this.copyTextToClipboard(names.join('、'))
      this.$message.success(`已复制 ${names.length} 个年级名称`)
    },
    copySingleGradeName(text) {
      if (!text) return
      this.copyTextToClipboard(text)
      this.$message.success(`已复制: ${text}`)
    },
    copyTextToClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).catch(() => {
          this.fallbackCopyText(text)
        })
      } else {
        this.fallbackCopyText(text)
      }
    },
    fallbackCopyText(text) {
      const textArea = document.createElement('textarea')
      textArea.value = text
      textArea.style.position = 'fixed'
      textArea.style.left = '-999999px'
      textArea.style.top = '-999999px'
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      try {
        document.execCommand('copy')
      } catch (err) {
        console.error('复制失败', err)
      }
      document.body.removeChild(textArea)
    },
    gradePreviewLines(ids) {
      const names = this.gradeLabelList(ids)
      if (!names.length) return ['未配置']
      const preview = names.slice(0, 4)
      const lines = []
      if (preview.length <= 2) {
        lines.push(preview.join('、'))
      } else {
        lines.push(preview.slice(0, 2).join('、'))
        const second = preview.slice(2, 4).join('、')
        lines.push(second + (names.length > 4 ? ` +${names.length - 4}` : ''))
      }
      return lines.filter(Boolean)
    },
    gradeTooltipLines(ids) {
      const names = this.gradeLabelList(ids)
      if (!names.length) return ['未配置']
      const lines = []
      for (let i = 0; i < names.length; i += 3) lines.push(names.slice(i, i + 3).join('、'))
      return lines
    },
    openClassCellDetails(row, column) {
      if (!row) return
      const prop = column && column.property
      const filter = { classDepartmentId: row.ClassDepartmentId }
      let title = row.ClassName || '班级'
      if (prop === 'MorningNormalCount' || prop === 'MorningExitedCount') { filter.attendanceItem = 'MORNING_EXIT'; filter.result = 'EXITED_OR_LATE'; title += ' · 离寝合计' }
      else if (prop === 'MorningNotExitedCount') { filter.attendanceItem = 'MORNING_EXIT'; filter.result = 'NOT_EXITED'; title += ' · 未离寝' }
      else if (prop === 'MorningLateExitCount') { filter.attendanceItem = 'MORNING_EXIT'; filter.result = 'LATE_EXIT'; title += ' · 晚离' }
      else if (prop === 'EveningNormalCount' || prop === 'EveningReturnedCount') { filter.attendanceItem = 'EVENING_RETURN'; filter.result = 'RETURNED_OR_LATE'; title += ' · 归寝合计' }
      else if (prop === 'EveningNotReturnedCount') { filter.attendanceItem = 'EVENING_RETURN'; filter.result = 'NOT_RETURNED'; title += ' · 未归寝' }
      else if (prop === 'EveningLateReturnCount') { filter.attendanceItem = 'EVENING_RETURN'; filter.result = 'LATE_RETURN'; title += ' · 晚归' }
      else if (prop === 'LeaveCount') {
        filter.attendanceItem = this.attendanceTab === 'morning' ? 'MORNING_EXIT' : 'EVENING_RETURN'
        filter.result = 'LEAVE'
        title += ' · 请假'
      }
      else if (prop === 'UnjudgedCount') {
        filter.attendanceItem = this.attendanceTab === 'morning' ? 'MORNING_EXIT' : 'EVENING_RETURN'
        filter.result = 'UNJUDGED'
        title += this.attendanceTab === 'morning' ? ' · 离寝未判定' : ' · 归寝未判定'
      }
      else if (prop === 'NotCheckedInCount') { filter.eligibilityStatus = 'NOT_CHECKED_IN'; title += ' · 未入住' }
      else if (prop === 'ResidentCount') { title += ' · ' + this.residentTypeName }
      else { title += ' · 学生明细' }
      this.openMetricDetails(title, filter)
    },
    summaryRowClassName() { return 'summary-click-row' },
    summaryCellClassName() { return 'summary-click-cell' },
    leaveCount(row) { return (row.MorningLeaveCount || 0) + (row.EveningLeaveCount || 0) },
    /** 当前离/归 Tab 下的请假人数 */
    tabLeaveCount(row) {
      if (!row) return 0
      return this.attendanceTab === 'morning' ? (row.MorningLeaveCount || 0) : (row.EveningLeaveCount || 0)
    },
    /** 当前离/归 Tab 下的未判定人数。最后更新：2026-10-23 */
    tabUnjudgedCount(row) {
      if (!row) return 0
      if (this.attendanceTab === 'morning') {
        return row.MorningUnjudgedCount != null ? row.MorningUnjudgedCount : 0
      }
      return row.EveningUnjudgedCount != null ? row.EveningUnjudgedCount : 0
    },
    normalRate(row) { const total = (row.MorningNormalCount || 0) + (row.MorningAbnormalCount || 0) + (row.EveningNormalCount || 0) + (row.EveningAbnormalCount || 0); return total ? Math.round(((row.MorningNormalCount || 0) + (row.EveningNormalCount || 0)) * 100 / total) : 0 },
    studentInitial(row) { const name = (row && row.StudentName) || ''; return name ? name.trim().slice(0, 1).toUpperCase() : '住' },
    dormDisplay(row) {
      const bedText = row && row.BedNumber ? `${row.BedNumber}床` : ''
      const parts = row ? [row.BuildingName, row.FloorName, row.RoomName, bedText].filter(Boolean) : []
      return parts.length ? parts.join(' / ') : '未分配'
    },
    resultText(v, row, item) {
      if (v === 'EXITED') return '已离寝'
      if (v === 'RETURNED') return '已归寝'
      if (v === 'NOT_EXITED') return '未离寝'
      if (v === 'LATE_EXIT') return '晚离'
      if (v === 'NOT_RETURNED') return '未归寝'
      if (v === 'LATE_RETURN') return '晚归'
      const text = { LEAVE: '请假' }[v]
      if (text) return text
      if (row && row.EligibilityStatus === 'NOT_CHECKED_IN') return '未入住'
      if (row && row.EligibilityStatus === 'NOT_APPLICABLE') return '不考勤'
      return '未判定'
    },
    eligibilityText(v) { return { ELIGIBLE: '已入住', NOT_APPLICABLE: '无需考勤', NOT_CHECKED_IN: '未入住' }[v] || '未入住' },
    resultType(v, row) {
      if (['EXITED', 'RETURNED'].includes(v)) return 'success'
      if (this.isProblemResult(v)) return 'warning'
      // 请假与问题态区分：不用 warning 橙黄，走自定义靛蓝标签。最后更新：2026-09-14
      if (v === 'LEAVE') return ''
      if (row && row.EligibilityStatus === 'NOT_CHECKED_IN') return 'info'
      return ''
    },
    resultTagClass(v) {
      return v === 'LEAVE' ? 'is-leave-tag' : ''
    }
  }
}
</script>

<style scoped>
.dorm-v3-page {
  height: 100%;
  max-height: 100%;
  min-height: 0;
  overflow: hidden;
  display: flex;
  align-items: stretch;
  color: #263548;
}

.page-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e8ecf1
}

.page-head h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600
}

.page-head p {
  margin: 5px 0 0;
  color: #7a8797;
  font-size: 13px
}

.page-head {
  flex-shrink: 0
}

.page-head>.department-pane {
  width: 0
}

.attendance-main {
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 12px 14px
}

.dorm-v3-tabs {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: transparent
}

.dorm-v3-tabs>>>.el-tabs__header {
  flex-shrink: 0;
  margin-bottom: 14px
}

.dorm-v3-tabs>>>.el-tabs__content {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.dorm-v3-tabs>>>.el-tab-pane.summary-tab-pane {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 规则 / 学生明细 / 核实记录：表体内滚。创建于 2026-09-01 */
.dorm-v3-tabs>>>.el-tab-pane.list-tab-pane {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.dorm-v3-tabs>>>.el-tab-pane.list-tab-pane > .toolbar-row {
  flex-shrink: 0;
}

.dorm-v3-tabs>>>.el-tab-pane.list-tab-pane > .tbl-scroll-host {
  flex: 1 1 auto;
  min-height: 0;
  height: 0;
  overflow: hidden;
}

.dorm-v3-tabs>>>.el-tab-pane.list-tab-pane > .tbl-scroll-host > .el-table {
  width: 100%;
  height: 100%;
}

.dorm-v3-tabs>>>.el-tab-pane.list-tab-pane > .dialog-pager-wrap {
  flex-shrink: 0;
}

.summary-tab-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.summary-tab-body > .toolbar-row {
  flex-shrink: 0;
}

.config-card {
  padding: 8px 4px 0
}

.config-card .el-form {
  max-width: 1080px
}

.config-explain {
  max-width: 1080px;
  margin-bottom: 14px
}

.config-explain>>>.el-alert__title {
  line-height: 1.5
}

.scope-caption {
  display: flex;
  align-items: center;
  gap: 7px;
  min-height: 34px;
  margin-bottom: 4px;
  color: #334155;
  font-size: 13px
}

.scope-caption i {
  color: #3b82f6
}

.scope-caption small {
  color: #94a3b8;
  margin-left: 4px
}

.form-tip {
  color: #8a96a5;
  font-size: 12px;
  margin-left: 14px
}

.toolbar-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 12px
}

.student-search-input {
  width: 220px;
  flex: 0 0 220px;
}

.mode-tip {
  flex: 1;
  min-width: 220px;
  color: #64748b;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 7px 10px;
  font-size: 12px;
  line-height: 1.4
}

.mode-tip i {
  margin-right: 5px;
  color: #0d9488
}

.summary-content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: hidden;
}

.summary-block {
  flex-shrink: 0;
  padding: 0 2px 10px;
  border-bottom: 1px solid #e8ecf1
}

.summary-block.is-collapsed {
  padding-bottom: 4px;
}

.summary-block-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  cursor: pointer;
  user-select: none;
}

.summary-block.is-collapsed .summary-block-head {
  margin-bottom: 0;
}

.summary-block-title {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.summary-block-title i {
  flex-shrink: 0;
  color: #94a3b8;
  font-size: 12px;
}

.summary-block-head strong {
  font-size: 14px;
}

.summary-block-head span {
  color: #8290a0;
  font-size: 12px
}

.metric-groups {
  display: grid;
  grid-template-columns: 0.7fr 1.1fr 1.1fr 1.1fr;
  gap: 10px;
}

.metric-group {
  min-width: 0;
  min-height: 104px;
  display: flex;
  flex-direction: column;
  padding: 8px;
  border: 1px solid #e8ecf1;
  border-radius: 8px;
  background: #fff;
}

.metric-group.evening {
  grid-column: span 2;
}

.metric-group-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.metric-group-head strong {
  color: #0f172a;
  font-size: 13px;
}

.metric-group-head span {
  color: #94a3b8;
  font-size: 11px;
  white-space: nowrap;
}

.metric-grid {
  display: grid;
  flex: 1;
  grid-template-columns: repeat(var(--metric-cols, 3), minmax(0, 1fr));
  gap: 8px;
  align-items: stretch;
}

.metric-grid div,
.metric-card {
  min-height: 64px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #f7f9fb;
  border-radius: 6px;
  padding: 10px 12px
}

.metric-grid em {
  display: block;
  color: #64748b;
  font-size: 12px;
  font-style: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.metric-group.evening .metric-card em {
  min-height: 30px;
  white-space: normal;
  line-height: 1.25;
}

.metric-grid b {
  display: block;
  margin-top: 6px;
  font-size: 20px;
  line-height: 1.2;
}

.metric-grid .ok {
  color: #18a66f
}

.metric-grid .bad {
  color: #e45d5d
}

.metric-grid .wait {
  color: #d99b2b
}

.metric-card {
  cursor: pointer;
  transition: background-color .16s ease, box-shadow .16s ease, transform .16s ease;
  min-width: 0
}

.metric-card em {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

.metric-card:hover {
  background: #ffffff;
  box-shadow: 0 6px 16px rgba(15, 23, 42, .08);
  transform: translateY(-1px)
}

.summary-link {
  cursor: pointer;
  color: #64748b
}

.summary-link:hover {
  color: #0d9488
}

.class-summary>>>.summary-click-row,
.class-summary>>>.summary-click-cell {
  cursor: pointer;
}

.class-summary>>>.summary-click-row:hover>td {
  background: #f8fafc !important;
}

.rule-table>>>th,
.rule-table>>>td {
  text-align: center;
}

.rule-table>>>.cell {
  padding-left: 12px;
  padding-right: 12px;
}

.rule-time-text {
  display: inline-block;
  white-space: nowrap;
  color: #334155;
  font-size: 13px;
}

.danger-text {
  color: #ef4444;
}

.danger-text:hover {
  color: #dc2626;
}

.rule-detail-toggle {
  margin-top: -4px;
}

.rule-detail-panel {
  margin-top: 4px;
}

.student-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  flex: 0 0 28px;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #ccfbf1;
  color: #0f766e;
  font-size: 12px;
  font-weight: 700;
}

.student-photo {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  overflow: hidden;
  background: #f1f5f9;
  cursor: pointer;
  vertical-align: middle;
}

.student-photo-error {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #94a3b8;
  font-size: 16px;
}

.grade-preview {
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: 1.35;
  min-width: 0;
}

.grade-preview-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #334155;
}

.grade-selected-box {
  margin-top: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #e5eaf1;
  background: #fbfdff;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.grade-selected-label {
  flex: 0 0 auto;
  margin: 0;
  color: #94a3b8;
  font-size: 12px;
  line-height: 1.6;
  white-space: nowrap;
}

.grade-selected-lines {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
}

.grade-selected-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #334155;
  font-size: 13px;
  line-height: 1.5;
}

.week-wrap {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.week-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.week-chip {
  appearance: none;
  border: 1px solid #dbe3ee;
  background: #fff;
  color: #475569;
  border-radius: 6px;
  padding: 7px 12px;
  min-width: 58px;
  cursor: pointer;
  transition: all .16s ease;
  line-height: 1;
}

.week-chip:hover {
  border-color: #38b2a6;
  color: #14b8a6;
  background: #f0fdfa;
}

.week-chip.active {
  border-color: #14b8a6;
  background: #14b8a6;
  color: #fff;
}

.week-tip {
  margin-left: 0;
}

.rule-time-block {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rule-time-inputs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.rule-time-inputs label {
  display: flex;
  flex-direction: column;
  gap: 5px;
  color: #64748b;
  font-size: 12px;
}

.rule-time-inputs>>>.el-date-editor.el-input {
  width: 100%;
}

.rule-time-axis {
  border: 1px solid #e5edf6;
  border-radius: 10px;
  padding: 10px 12px 8px;
  background: linear-gradient(180deg, #fbfdff 0%, #f8fafc 100%);
}

.axis-track {
  position: relative;
  display: grid;
  grid-template-columns: 56% 44%;
  height: 32px;
  overflow: hidden;
  border-radius: 999px;
  color: #334155;
  font-size: 12px;
  line-height: 32px;
  text-align: center;
}

.axis-track::after {
  content: '';
  position: absolute;
  left: 56%;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #0d9488;
  box-shadow: 0 0 0 4px rgba(13, 148, 136, .12);
}

.axis-before {
  background: #ecfdf5;
  color: #047857;
}

.axis-after {
  background: #fff7ed;
  color: #c2410c;
}

.rule-time-axis.evening .axis-after {
  background: #eff6ff;
  color: #1d4ed8;
}

.axis-points {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  color: #94a3b8;
  font-size: 12px;
}

.axis-points span {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.axis-points span:nth-child(2) {
  text-align: center;
  color: #0f766e;
}

.axis-points span:last-child {
  text-align: right;
}

.axis-points b {
  color: #334155;
  font-size: 13px;
}

.time-rule-tip {
  margin-left: 0;
  line-height: 1.5;
}

.dialog-pager-wrap {
  display: flex;
  justify-content: flex-end;
}

.dorm-grade-tooltip .grade-tooltip-content {
  line-height: 1.6;
}

.dialog-pager {
  margin-top: 14px;
  margin-left: 0;
  text-align: right;
  box-shadow: none;
  padding: 0 0 0 16px;
  background: transparent;
}

/* 指标明细弹窗。最后修改：2026-08-31 */
.metric-detail-toolbar {
  margin-bottom: 10px;
}

.metric-detail-search {
  width: 220px;
  flex: 0 0 220px;
}

.metric-detail-pager {
  margin-top: 14px;
  padding-top: 2px;
}

.metric-detail-pager .dialog-pager {
  margin-top: 0;
}

.bar-line {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  color: #768495;
  font-size: 12px
}

.bar-line i {
  flex: 1;
  background: #e9edf2;
  height: 6px;
  border-radius: 3px;
  overflow: hidden
}

.bar-line i b {
  display: block;
  height: 100%;
  background: #21a875
}

.class-summary {
  flex: 1;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.class-summary-table-host {
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}

.class-summary-table-host>>>.el-table {
  height: 100% !important;
}

.class-summary-table-host>>>.el-table__header-wrapper {
  overflow: hidden !important;
}

/* 固定高度表体纵向滚动时，gutter 列会多出一条无意义的横向滚动条 */
.class-summary-table-host>>>.el-table--scrollable-y .el-table__body-wrapper {
  overflow-x: hidden !important;
}

.class-summary-table-host>>>.el-table__body-wrapper {
  overflow-y: auto !important;
}

.class-summary-pager {
  flex-shrink: 0;
  padding-top: 8px;
}

.class-summary-pager>>>.el-pagination {
  flex-wrap: wrap;
  row-gap: 6px;
  justify-content: flex-end;
}

.section-head {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 2px 6px
}

.section-head>div {
  display: flex;
  align-items: baseline;
  gap: 10px
}

.section-head strong {
  font-size: 14px
}

.section-head span,
.section-head small {
  color: #8a96a5;
  font-size: 12px
}

@media (max-width: 1480px) {
  .metric-groups {
    grid-template-columns: 1fr 1fr;
  }

  .metric-group-head span {
    white-space: normal;
  }
}

@media (max-width: 1280px) {
  .metric-groups {
    grid-template-columns: 1fr;
  }

  .section-head span {
    display: none;
  }

  .mode-tip {
    flex: 1 1 100%;
    min-width: 0;
  }

  .toolbar-row {
    flex-wrap: wrap;
  }

  /* 窄屏列总宽超出容器时，才允许横向滑动 */
  .class-summary-table-host>>>.el-table--scrollable-y .el-table__body-wrapper {
    overflow-x: auto !important;
  }
}
</style>

<style>
/* 指标明细弹窗挂到 body，需全局样式。最后修改：2026-08-31 */
.metric-detail-dialog {
  margin-top: 6vh !important;
}

.metric-detail-dialog .el-dialog__body {
  padding-top: 16px;
  padding-bottom: 12px;
}

.metric-detail-dialog .metric-detail-table-wrap {
  height: 460px;
  min-height: 460px;
  overflow: hidden;
}

.metric-detail-dialog .metric-detail-table {
  height: 100%;
}

.metric-detail-dialog .metric-detail-table .el-table__body-wrapper {
  overflow-x: auto !important;
  overflow-y: auto !important;
}

.metric-detail-dialog .metric-detail-table .el-table__empty-block {
  min-height: 380px;
}

/* 宿舍考勤规则年级查看按钮与弹窗。最后更新：2026-09-08 */
.kq-dept-link-btn {
  padding: 4px 10px;
  font-size: 13px;
  color: #2563eb;
  background-color: #eff6ff;
  border-radius: 4px;
  line-height: 18px;
  border: 1px solid #bfdbfe;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.kq-dept-link-btn:hover,
.kq-dept-link-btn:focus {
  color: #1d4ed8;
  background-color: #dbeafe;
  border-color: #93c5fd;
}

.ac-empty-dash {
  color: #9ca3af;
  font-size: 14px;
}

.kq-dept-view-dialog .el-dialog__body {
  padding: 16px 20px 10px;
}

.kq-view-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 10px 16px;
  margin-bottom: 14px;
}

.kq-view-head-item {
  font-size: 13px;
  color: #334155;
}

.kq-view-head-item .label {
  color: #64748b;
}

.kq-view-head-item .val {
  font-weight: 500;
  color: #0f172a;
}

.kq-view-head-item .count-badge {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 12px;
  font-size: 12px;
  background-color: #eff6ff;
  color: #2563eb;
  font-weight: 600;
}

.kq-view-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.kq-view-search-input {
  max-width: 280px;
}

.kq-view-table-wrap {
  border-radius: 4px;
  overflow: hidden;
}

.kq-view-table .dept-text {
  font-size: 13px;
  color: #1e293b;
  font-weight: 500;
}

.kq-view-empty {
  padding: 30px 0;
  color: #94a3b8;
  font-size: 13px;
}

/* 请假标签：靛蓝，与未离寝等 warning 橙黄区分。最后更新：2026-09-14 */
.el-tag.is-leave-tag {
  background-color: #e0e7ff;
  border-color: #c7d2fe;
  color: #4338ca;
}
</style>
